export default {
  causedByCountyError: null,
  paidInFull: null,
  doesNotExceedPenalty: null,
  assignedBecauseOfFailure: null,
  noPenaltyUnderUCA: null,
  filedDelinquentStatement: null,
  business: {
    accountNo: '',
    busAddr: {
      street: '',
      city: '',
      state: '',
      zip: '',
    },
    businessName: '',
    businessPhone: '',
    email: '',
    ownerName: '',
    ownerPhone: '',
    mailAddr: {
      street: '',
      city: '',
      state: '',
      zip: '',
    },
    statement: '',
    agreedToTerms: false,
  },
  scheduleB: [],
};
